module.exports = __webpack_public_path__ + "img/hotel-yellow.9a10c8a6.png";